import React from "react";
import AppLayout from "../../components/AppLayout";

export default function ComingSoon({ title, eyebrow, description, icon: Icon, mockRows, columns, ctaLabel, accent = "lime" }) {
    return (
        <AppLayout searchPlaceholder={`Search ${title.toLowerCase()}...`}>
            <div className="flex flex-wrap items-end justify-between gap-4 mb-8">
                <div>
                    <span className="text-xs uppercase tracking-widest text-grape font-semibold">{eyebrow}</span>
                    <h1 className="font-display font-black text-4xl sm:text-5xl tracking-tight mt-2">{title}</h1>
                    <p className="text-sm text-gray-400 mt-2 max-w-2xl">{description}</p>
                </div>
                <button data-testid={`${title.toLowerCase().replace(/\s+/g, "-")}-cta`} disabled className={`inline-flex items-center gap-2 px-5 py-2.5 rounded-full ${accent === "lime" ? "bg-lime text-ink-900" : "bg-grape text-white"} text-sm font-bold opacity-60 cursor-not-allowed`}>
                    {ctaLabel}
                </button>
            </div>

            <div className="bg-gradient-to-br from-grape/10 via-ink-700 to-lime/5 border border-white/10 rounded-3xl p-6 mb-8 flex items-center gap-4">
                {Icon && <div className="w-12 h-12 rounded-2xl bg-white/5 flex items-center justify-center"><Icon className="w-6 h-6 text-lime" /></div>}
                <div>
                    <div className="font-display font-bold text-lg">Preview only</div>
                    <p className="text-sm text-gray-400">This module is being wired up. The data below is illustrative — actions are disabled until launch.</p>
                </div>
            </div>

            <div className="bg-ink-700 rounded-3xl border border-white/5 overflow-hidden">
                <div className="overflow-x-auto">
                    <table className="w-full">
                        <thead>
                            <tr className="text-xs uppercase text-gray-500 tracking-widest bg-ink-800">
                                {columns.map((c) => <th key={c} className="text-left font-medium px-6 py-4">{c}</th>)}
                            </tr>
                        </thead>
                        <tbody>
                            {mockRows.map((r, i) => (
                                <tr key={i} className="border-t border-white/5">
                                    {r.map((cell, j) => <td key={j} className="px-6 py-4 text-sm text-gray-300">{cell}</td>)}
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        </AppLayout>
    );
}
